// features/client/client.dependencies.js

import apiUser from "../../api";

export const loadDependencies = async () => {
  const [
    companiesRes,
    countriesRes,
    tradesRes,
    designationsRes,
    adminsRes,
    userRolesRes
  ] = await Promise.allSettled([
    apiUser.getCompanies(),
    apiUser.getCountries(),
    apiUser.getTrades(),
    apiUser.getDesignations(),
    apiUser.getAllClients({ role: "ADMIN" }),
    apiUser.getAllUserRoles()
  ]);

  const extract = (res) =>
    res.status === "fulfilled"
      ? res.value?.data?.data || []
      : [];

  const admins = extract(adminsRes).map(admin => ({
    ...admin,
    full_name: `${admin.first_name || ""} ${admin.last_name || ""}`.trim()
  }));

  return {
    companies: extract(companiesRes),
    countries: extract(countriesRes),
    trades: extract(tradesRes),
    designations: extract(designationsRes),
    admins,
    userRoles: extract(userRolesRes).map(role => ({
      ...role,
      role: role.role
    }))
  };
};